import { client } from './client';

const API_ENDPOINT = process.env.REACT_APP_MS_CUSTOMERS_IMPORTS;

class ImportCustomersDataService {

  static sendFile(path = '', params) {
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
      formData.append(key, value);
    })
    return client({
      method: 'POST',
      url: path,
      baseURL: API_ENDPOINT,
      data: formData,
    });
  }

  static post(path = '', data = {}) {
    return client({
      method: 'POST',
      url: path,
      baseURL: API_ENDPOINT,
      data,
    });
  }

}

export { ImportCustomersDataService }